module.exports = __webpack_public_path__ + "static/media/6_1.3ba04ca3.png";